module.exports = new __parcel__URL__("institutionIcon.189ff731.svg").toString();